<template>
  <div>
    <v-alert v-model="errorAlert" dismissible dense outlined type="error">
      <span> {{ errorMsg }} </span>
    </v-alert>
    <v-sheet>
      <v-row>
        <v-col cols="12">
          <div>
            <v-btn
              small
              class="text-capitalize float-right ma-2"
              color="primary"
              dark
              width="100"
              :loading="editing"
              @click="editChecker()"
              >{{ $t("Edit") }}</v-btn
            >
          </div>
        </v-col>
        <v-col cols="12" class="pa-0">
          <v-form class="main-form pa-3" ref="form">
            <v-container>
              <v-row>
                <v-col cols="12" sm="4">
                  <v-text-field
                    placeholder=" "
                    :label="$t('Name')"
                    v-model="checker.name"
                    dense
                    outlined
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    placeholder=" "
                    :label="$t('LastName')"
                    v-model="checker.lastName"
                    dense
                    outlined
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    placeholder=" "
                    :label="$t('Phone')"
                    v-model="checker.phone"
                    dense
                    outlined
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>
<script>
import RestResourceChecker from "@/api/apiCheckerService";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ResponseStatus } from "@/models/ResponseStatusEnum";
import { AdminRoles } from "@/models/AdminRolesEnum";
export default {
  name: "EditChecker",
  props: {
    checkerProp: Object
  },
  components: {},
  data() {
    return {
      roles: AdminRoles,
      editing: false,
      errorMsg: "",
      errorAlert: false,
      checker: {
        _id: "",
        name: "",
        lastName: "",
        phone: "",
        email: ""
      },
      rules: {
        email: v => {
          const re = /^(([^<>()[\]\\.`,{//=!}*^&%#;:\s@"]+(\.[^<>()[\]\\.`,{//=!}*^&%#;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (re.test(v)) return true;
          return this.$t("errors.mustBeValidEmail");
        },
        required: v => {
          if (v) {
            return true;
          }
          return this.$t("errors.requiredField");
        }
      }
    };
  },
  watch: {
    checkerProp: {
      handler() {
        this.checker = Object.assign({}, this.checkerProp);
      },
      deep: true
    }
  },
  methods: {
    editChecker() {
      if (this.$refs.form.validate()) {
        this.editing = true;
        RestResourceChecker.prototype
          .putChecker(this.checker._id, {
            name: this.checker.name,
            lastName: this.checker.lastName,
            phone: this.checker.phone
          })
          .then(response => {
            if (response && response.status == ResponseStatus.OK) {
              this.$router.push({ name: "checker_accounts" });
            }
            this.editing = false;
          })
          .catch(error => {
            this.errorMsg = error.response.data.message;
            this.errorAlert = true;
            this.editing = false;
          });
      }
    }
  }
};
</script>
<style></style>
